// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3FlS1","notes":"Notes_notes__3Oauj"};